export default function() {
	return function (value) {
        return Math.ceil(value);
    }
}


// WEBPACK FOOTER //
// ./client/components/filters/roundUp.js